import { SharedUserGuard } from '@agroone-front/shared'
import { AgropilotFeature, AgropilotRoleHasFeatureAccess, UserDto } from '@agroone/entities'
import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router'
import { Observable } from 'rxjs'
import { filter, map, tap } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class UserGuard extends SharedUserGuard {
  private _router = inject(Router)

  override canActivate(next: ActivatedRouteSnapshot, _: RouterStateSnapshot): Observable<boolean> {
    let agropilotFeature: AgropilotFeature | { [feature: string]: 'read' | 'write' } =
      next.data.agropilotFeature || null

    if (agropilotFeature == null) {
      return super.canActivate(next, _)
    }

    if (typeof agropilotFeature === 'string') {
      agropilotFeature = { [agropilotFeature]: 'read' }
    }

    return this.userService.user.pipe(
      filter((user) => !!user),
      map((user: UserDto) =>
        this._userHasFeatureAccess(user, agropilotFeature as { [feature: string]: 'read' | 'write' }),
      ),
      tap((hasPermission) => {
        if (!hasPermission) {
          this.logger.warn(`Access denied - Permission(s) ${agropilotFeature} required`)
          this.toastService.showToastWarning(this.translate.instant('PERMISSION.ACCESS_DENIED'))
          this._router.navigate(['/'])
        }
      }),
    )
  }

  private _userHasFeatureAccess(user: UserDto, features: { [feature: string]: 'read' | 'write' } = {}): boolean {
    const role = user?.agropilotRole
    for (const feature in features) {
      // An unknown role has no access: skip the lookup when the user has none
      if (role != null && AgropilotRoleHasFeatureAccess(role, feature as AgropilotFeature, features[feature])) {
        return true
      }
    }

    return false
  }
}
